// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syazi7uo{color:var(--ds-text,#292a2e)}", ""]);
// Exports
module.exports = exports;
